import { createRoot } from "react-dom/client";
import Chart from './d3';

const container = document.getElementById("app");
const root = createRoot(container)
root.render(<Chart />);
